export default __webpack_public_path__ + "static/img_4-6a54dbeb779210fee94df9ac210b963a.webp";